function applyRippleTo(selector) {
  document.querySelectorAll(selector).forEach((el) => {
    el.addEventListener("click", function (e) {
      const ripple = document.createElement("span");
      ripple.classList.add("ripple");

      // Optional color via data-ripple or class
      const customColor = el.getAttribute("data-ripple");
      if (customColor) ripple.style.backgroundColor = customColor;

      const extraClass = [...el.classList].find(c => c.startsWith("ripple--"));
      if (extraClass) ripple.classList.add(extraClass);

      const diameter = Math.max(el.clientWidth, el.clientHeight);
      const radius = diameter / 2;

      ripple.style.width = ripple.style.height = `${diameter}px`;
      ripple.style.left = `${e.offsetX - radius}px`;
      ripple.style.top = `${e.offsetY - radius}px`;

      const oldRipple = el.querySelector(".ripple");
      if (oldRipple) oldRipple.remove();

      el.appendChild(ripple);
    });
  });
}

// Run it globally on elements with .ripple-wrapper
document.addEventListener("DOMContentLoaded", () => {
  applyRippleTo(".ripple-wrapper");
});
